import { useQuery } from '@tanstack/react-query';

import { request } from '@paid-ui/utils/axios';

interface BusinessABNCheckParams {
  abn: string;
}
type BusinessABNCheckResponse = { data: boolean } | null;

export const useBusinessABNCheck = (params: BusinessABNCheckParams) => {
  const { abn } = params;

  return useQuery({
    retry: false,
    enabled: false,
    queryKey: ['BusinessABNCheck', abn],
    queryFn: async ({ signal }) => {
      const { data } = await request.get<BusinessABNCheckResponse>('/business/abn-check', {
        signal,
        params: {
          abn: abn.trim(),
        },
      });
      return data?.data;
    },
  });
};
